export default function _strf(string, params) {
	if (typeof window !== "undefined" && window._strf) {
		return window._strf(string, params);
	}

	return string;
}



// WEBPACK FOOTER //
// ./src/shared/util/_strf.js